require('core-js/es6/promise');
require('core-js/fn/array');
require('core-js/fn/object');
require('core-js/fn/string');
require('core-js/fn/map');
